module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "container"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-lg-12"
  }, [_vm._m(0), _vm._v(" "), _c('div', [_c('svg', {
    attrs: {
      "xmlns": "http://www.w3.org/2000/svg",
      "width": "30%",
      "viewBox": "0 0 64 64",
      "enable-background": "new 0 0 64 64"
    }
  }, [_c('path', {
    attrs: {
      "d": "M32,2c-13.4,0-20.8,8.5-20.8,19.7v22.7h41.6V21.7c0-16.7-11.2-16.4-11.2-16.4S40.7,2,32,2z",
      "fill": "#ffb300"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "m51.1 36.7c-5.2-4.7-19 4.3-19.1 4.3-.1-.1-13.9-9-19.1-4.3-4.8 4.4.8 25.3.8 25.3h36.5c.1 0 5.7-20.9.9-25.3",
      "fill": "#c28fef"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "m17.7 33.2c0 0-3.1-.2-3.9-4.7-.6-3.5 1.5-4.6 1.5-4.6 7.7-3.9 19.3-14.3 19.3-14.3s5.4 5.4 11.6 8.9c0 0 2.4 0 3.1 3.8.8 4.5-2.2 5.8-2.2 5.8 1.2 6.8-6.5 16.5-12 17.5-5.5.9-16.2-5.6-17.4-12.4",
      "fill": "#ffdd67"
    }
  }), _vm._v(" "), _c('g', {
    attrs: {
      "fill": "#937237"
    }
  }, [_c('path', {
    attrs: {
      "d": "m28.6 40.9c-.1 0-.2-.1-.2-.2-.1-.7 2.2-2.7 5.2-3.2 3.1-.5 5.8.5 6 1.2 0 .1 0 .2-.1.3 0 0-2.6-1.1-5.7-.5-3 .5-5.2 2.4-5.2 2.4"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "m18.1 23c-.1-.1-.1-.1-.1-.2 0-.6 2-1.5 4.6-1.6 2.6-.2 4.8.4 4.8 1.1 0 .1 0 .2-.1.2 0 0-2.1-.4-4.6-.2-2.6.1-4.6.7-4.6.7"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "m42.8 16.7c.1-.1.1-.2 0-.2-.2-.6-2.5-.5-4.9.4-2.4.9-4.1 2.4-3.9 2.9 0 .1.1.1.2.2 0 0 1.7-1.2 4.1-2.1 2.4-1 4.5-1.2 4.5-1.2"
    }
  })]), _vm._v(" "), _c('path', {
    attrs: {
      "d": "m37 34.4c.2 1-2.8 1.8-3.5 2-.7.1-3.8.3-3.9-.7-.1-.1 7.3-1.8 7.4-1.3",
      "fill": "#eba352"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "m27.1 29.8c.9-.2.4-2.4.4-2.4-3.7-5.5-8.9-.7-8.9-.7-2.1 1.4 1.8 4.1 2.3 4.1 2.6.3 6.2-1 6.2-1",
      "fill": "#f5f5f5"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "m26 27.1c.3 1.6-.8 3-2.3 3.3-1.6.3-3-.8-3.3-2.3-.3-1.6.8-3 2.3-3.3 1.6-.3 3.1.8 3.3 2.3",
      "fill": "#664e27"
    }
  }), _vm._v(" "), _c('g', {
    attrs: {
      "fill": "#231f20"
    }
  }, [_c('path', {
    attrs: {
      "d": "m24.2 27.5c.1.5-.3 1.1-.8 1.2-.5.1-1.1-.3-1.2-.8-.1-.5.3-1.1.8-1.2.6-.1 1.1.2 1.2.8"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "m28.4 28.1c-.9-.8-1.7-1.5-2.7-2-.9-.5-1.9-.7-3-.6-1 .1-2 .5-3.1.9-.5.2-1.1.4-1.7.5-.6.1-1.3.2-1.7-.2.6.1 1.1-.1 1.6-.3.5-.2 1-.5 1.5-.8 1-.6 2.1-1.1 3.4-1.2.6 0 1.3 0 1.9.2.6.2 1.2.5 1.7.8.8.7 1.6 1.7 2.1 2.7"
    }
  })]), _vm._v(" "), _c('path', {
    attrs: {
      "d": "m37.1 28c-.9.2-1.1-2.1-1.1-2.1 1.6-6.4 8.2-3.7 8.2-3.7 2.5.6-.3 4.4-.8 4.7-2.4 1.1-6.3 1.1-6.3 1.1",
      "fill": "#f5f5f5"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "m42.9 24.2c.3 1.6-.8 3-2.3 3.3-1.6.3-3-.8-3.3-2.3-.3-1.6.8-3 2.3-3.3 1.6-.3 3 .7 3.3 2.3",
      "fill": "#664e27"
    }
  }), _vm._v(" "), _c('g', {
    attrs: {
      "fill": "#231f20"
    }
  }, [_c('path', {
    attrs: {
      "d": "m41.1 24.5c.1.5-.3 1.1-.8 1.2-.5.1-1.1-.3-1.2-.8-.1-.5.3-1.1.8-1.2.6-.1 1.1.3 1.2.8"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "m35.4 26.9c.1-1.1.5-2.3 1.2-3.3.3-.5.8-1 1.3-1.3.5-.4 1.1-.6 1.7-.8 1.2-.3 2.4-.2 3.6 0 .6.1 1.1.2 1.7.3.5.1 1.1.1 1.6-.2-.3.5-1 .7-1.6.8-.6.1-1.2.1-1.7.1-1.1 0-2.2 0-3.2.2-1 .2-1.9.8-2.6 1.6-.9.6-1.4 1.6-2 2.6"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "m16.6 49.9l-.8 12.1h11.1l-1.3-12.8h-.8c-.1-.7-.2-1.4-1.1-3.2-1.5-3.3-7.4-2.1-9.7-1.5l-2 5.5c3.6.4 4.6-.1 4.6-.1",
      "opacity": ".2"
    }
  })]), _vm._v(" "), _c('path', {
    attrs: {
      "d": "m17.4 50.4v-1.1c0 0-10.2 2.1-14-1.4-4.8-4.5 3.4-2 9.6-3.5 2.2-.6 8.1-1.7 9.7 1.5 1.7 3.5 1.3 4.5 1.3 4.5h-6.6",
      "fill": "#ffdd67"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "fill": "#c28fef",
      "d": "m16.3 62l.8-12.3h7.7l1.1 12.3z"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "m47.4 49.9l.8 12.1h-11.1l1.3-12.8h.8c.1-.7.2-1.4 1.1-3.2 1.5-3.3 7.4-2.1 9.7-1.5l2 5.6c-3.6.3-4.6-.2-4.6-.2",
      "opacity": ".2",
      "fill": "#231f20"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "m46.6 50.4v-1.1c0 0 10.2 2.1 14-1.4 4.8-4.5-3.4-2-9.6-3.5-2.2-.6-8.1-1.7-9.7 1.5-1.7 3.5-1.3 4.5-1.3 4.5h6.6",
      "fill": "#ffdd67"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "fill": "#c28fef",
      "d": "m47.7 62l-.8-12.3h-7.7l-1.1 12.3z"
    }
  })])]), _vm._v(" "), _vm._m(1)])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "page-header"
  }, [_c('h1', [_vm._v("Error 404 - Not Found")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', [_vm._v("Emoji provided for free by "), _c('a', {
    attrs: {
      "href": "http://emojione.com",
      "target": "_blank"
    }
  }, [_vm._v("EmojiOne")]), _vm._v(".")])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-ebe39b22"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/pages/NotFound.vue
// module id = 634
// module chunks = 1